import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

export const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'job-watchlist',
});

export function addJobWatchlist(jobId) {
    return backendEndpoint.post(`${jobId}`);
}

export function removeJobWatchlist(watchlistId) {
    return backendEndpoint.delete(`${watchlistId}`);
}
